module.exports = __webpack_public_path__ + "img/inboxes.93fdc823.svg";